module.exports = __webpack_public_path__ + "static/media/291861.247b400b.png";